import {
  ArrayFilters,
  DefaultFilters,
  WithOptionsFilterFilters,
} from '@/src/components/organism/Filter/types';
import { LanguageCode } from '@/src/types/common';

export const recyclingPackageProductFilters: () => (
  | DefaultFilters
  | WithOptionsFilterFilters
  | ArrayFilters
)[] = () => [
  {
    key: 'id',
    label: 'ID',
    placeholder: 'ID를 입력해주세요',
  },
  {
    key: 'createdAt',
    label: '등록 일자',
    type: 'DATE_RANGE',
    rangeKeys: ['createdAtFrom', 'createdAtTo'],
  },
  {
    key: 'nameLike',
    label: '수거 품목 명',
    placeholder: '품목명',
  },
];
